export default "__VITE_ASSET__C3Ofo2jL__"